import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-context-menu',
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.less'],
    standalone: false
})
export class ContextMenuComponent implements OnInit {

  @Input()
  items: ContextMenuItem[] = [];

  @Input()
  pos: ContextMenuPosition | null = null;

  get posX(){ return `${this?.pos?.x}px`; }
  get posY(){ return `${this?.pos?.y}px`; }

  @Output('select') 
  itemSelected = new EventEmitter<ContextMenuItem>();

  @Output('close') 
  close = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  itemClick(it: ContextMenuItem){
    this.itemSelected.emit(it);
    this.close.emit();
  }

  closeClick(){
    this.close.emit();    
  }
}


export interface ContextMenuItem {
  name: string;
  value: any;
}

export interface ContextMenuPosition {
  x: number;
  y: number;
}